import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronUpCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 2A14 14 0 1 1 2 16C2 5.6 11 2 16 2M9.3 18.7a1 1 0 0 0 1.4 0l5.3-5.3 5.3 5.3a1 1 0 0 0 1.4 0 1 1 0 0 0 0-1.4l-6-6a1 1 0 0 0-1.4 0l-6 6a1 1 0 0 0 0 1.4"
    />
  </svg>
);
const ForwardRef = forwardRef(IconChevronUpCircleFilledSVG);
ForwardRef.displayName = "IconChevronUpCircleFilled";
export { ForwardRef as IconChevronUpCircleFilled };
